<template>
	<div class="max-w-520px min-h-96 text-center z-20 grid content-center">
		<h1
			class="font-medium mb-4 text-6xl"
			v-text="`${statusCode} - ${statusMessage}`"
		/>
		<p
			class="font-light leading-tight mb-8 px-8 sm:px-0 text-2xl"
			v-text="message"
		/>
		<div class="flex items-center justify-center w-full">
			<NuxtLink
				to="/"
				class="cursor-pointer border border-solid px-4 py-2 sm:px-6 sm:py-3 sm:text-xl text-md"
			>
				{{ backHome }}
			</NuxtLink>
		</div>
	</div>
</template>

<script setup>
defineProps({
	statusCode: {
		type: Number,
		default: 404
	},
	statusMessage: {
		type: String,
		default: "Not Found"
	},
	message: {
		type: String,
		default: "Sorry, the page you are looking for could not be found."
	},
	backHome: {
		type: String,
		default: "Go back home"
	}
});
</script>
